import * as actions from './actions';
import * as selectors from './selectors';
import types, { moduleName } from './types';

export { actions as default, moduleName as NAME, selectors, types };
